module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_314639.23518b65.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_314639.pdf
// module id = 327
// module chunks = 0